package cc.bluepeak.clubmanager.site.components.sections

import androidx.compose.runtime.Composable
import cc.bluepeak.clubmanager.site.Res
import cc.bluepeak.clubmanager.site.styles.CardStyle
import cc.bluepeak.clubmanager.site.styles.Theme
import cc.bluepeak.clubmanager.site.styles.toSitePalette
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun FeatureCard(
    title: String, description: String, index: Int, total: Int,
    icon: @Composable () -> Unit,
) {
    Column(CardStyle.toModifier().padding(1.cssRem).height(28.cssRem).width(20.cssRem)) {
        Box(
            Modifier.padding(4.px).backgroundColor(Theme.primary)
                .boxShadow(0.px, 4.px, blurRadius = 8.px, color = Theme.primary)
                .borderRadius(Theme.shapes.medium)
        ) {
            icon()
        }
        H3(Modifier.margin(top = 3.cssRem, bottom = 1.cssRem).toAttrs()) {
            Text(title)
        }
        P(Modifier.color(Theme.secondary).toAttrs()) {
            Text(description)
        }
        Spacer()
        Row(
            Modifier.fillMaxWidth().fontSize(4.cssRem).fontWeight(600),
            horizontalArrangement = Arrangement.End
        ) {
            SpanText(index.toString().padStart(2, '0'), Modifier.color(Theme.secondary.copyf(alpha = 0.8f)))
            SpanText("/${total.toString().padStart(2, '0')}", Modifier.color(Theme.secondary.copyf(alpha = 0.5f)))
        }
    }
}

val FeatureImageCardStyle = CssStyle {
    base {
        Modifier.backgroundColor(colorMode.toSitePalette().surfaceVariant).borderRadius(Theme.shapes.medium)
            .padding(1.cssRem)
    }
}

@Composable
fun FeatureImageCard(
    title: String,
    description: String,
    index: Int,
    image: String,
    modifier: Modifier = Modifier,
    link: String? = null,
) {
    Column(FeatureImageCardStyle.toModifier().then(modifier), verticalArrangement = Arrangement.spacedBy(1.cssRem)) {
        Box(Modifier.fillMaxWidth()) {
            Image(image, Modifier.fillMaxWidth().borderRadius(Theme.shapes.medium))
        }
        Row(horizontalArrangement = Arrangement.spacedBy(1.cssRem)) {
            SpanText(
                "//" + index.toString().padStart(2, '0'),
                Modifier.color(Theme.secondary.copyf(alpha = 0.8f)).margin(top = 2.px)
            )
            Column {
                H3 {
                    Row(
                        Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(1.cssRem)
                    ) {
                        Text(title)
                        link?.let {
                            Link(
                                link,
                                Res.string.learn_more,
                                Modifier.fontSize(FontSize.Smaller).fontWeight(FontWeight.Light)
                            )
                        }
                    }
                }
                P {
                    Text(description)
                }
            }
        }
    }
}